import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../../services/apiClient";
import { setCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

const REGISTER_INITIAL_STATE = {
  name: "",
  mobileNo: "",
  email: "",
  referalID: "",
};

const LOGIN_INITIAL_STATE = {
  userID: "",
  password: "",
};

const BEFORE_LOGIN_POPUP_IMAGE_URL =
  "https://api.learning2earning.net/Image/Website/1/Popup/AppBeforeLogin.png";

export default function Login() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [registerForm, setRegisterForm] = useState(REGISTER_INITIAL_STATE);
  const [isRegistering, setIsRegistering] = useState(false);
  const [registerError, setRegisterError] = useState("");
  const [loginForm, setLoginForm] = useState(LOGIN_INITIAL_STATE);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [registeredCreds, setRegisteredCreds] = useState(null);
  const [referrerName, setReferrerName] = useState("");
  const [isReferrerLoading, setIsReferrerLoading] = useState(false);
  const [referrerNotFound, setReferrerNotFound] = useState(false);
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [forgotUserId, setForgotUserId] = useState("");
  const [isSendingForgot, setIsSendingForgot] = useState(false);
  const [beforeLoginPopupUrl, setBeforeLoginPopupUrl] = useState(null);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [otpMobile, setOtpMobile] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [otpLocation, setOtpLocation] = useState({
    latitude: "",
    longitude: "",
  });
  const [otpSession, setOtpSession] = useState("");

  useEffect(() => {
    const img = new Image();
    img.onload = () => setBeforeLoginPopupUrl(BEFORE_LOGIN_POPUP_IMAGE_URL);
    img.onerror = () => setBeforeLoginPopupUrl(null);
    img.src = BEFORE_LOGIN_POPUP_IMAGE_URL;
  }, []);

  function handleRegisterChange(e) {
    const { name, value } = e.target;
    setRegisterForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleLoginChange(e) {
    const { name, value } = e.target;
    setLoginForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleLoginSubmit() {
    setLoginError("");
    setIsLoggingIn(true);
    try {
      const res = await apiClient.post("/App/Login", {
        LoginSource: "UserLogin",
        appid: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        imei: "8545424a0797e8aa",
        loginTypeID: 1,
        password: loginForm.password,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        userID: loginForm.userID,
        version: "1.0",
      });

      if (res.statuscode !== 1) {
        setLoginError(res.msg);
        toast.error(res.msg);
        return;
      }

      setCookie("sessionID", res.data.sessionID);
      setCookie("session", res.data.session);
      setCookie(
        "userData",
        JSON.stringify({
          userID: res.data.userID,
          name: res.data.name,
          prefix: res.data.prefix,
          mobileNo: res.data.mobileNo,
          emailID: res.data.emailID,
          roleID: res.data.roleID,
          roleName: res.data.roleName,
          outletID: res.data.outletID,
        }),
      );

      toast.success(res.msg);
      navigate("/panel/dashboard");
    } catch (err) {
      const message =
        err.response?.data?.message || "Login failed. Please try again.";
      setLoginError(message);
      toast.error(message);
    } finally {
      setIsLoggingIn(false);
    }
  }

  function openOtpModal() {
    setOtpMobile("");
    setOtpValue("");
    setIsOtpSent(false);
    setOtpSession("");
    setIsOtpModalOpen(true);
    setOtpLocation({ latitude: "", longitude: "" });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setOtpLocation({
            latitude: String(position.coords.latitude),
            longitude: String(position.coords.longitude),
          });
        },
        (err) => {
          console.log("geolocation error", err);
        },
      );
    }
  }

  function closeOtpModal() {
    setIsOtpModalOpen(false);
    setOtpMobile("");
    setOtpValue("");
    setIsOtpSent(false);
    setOtpSession("");
  }

  async function handleSendOtp() {
    if (!otpMobile.trim()) {
      toast.error("Please enter User ID or Mobile No");
      return;
    }

    setIsSendingOtp(true);
    try {
      const res = await apiClient.post("/App/LoginWithOTP", {
        Latitude: otpLocation.latitude,
        Longitude: otpLocation.longitude,
        OTP: "",
        Password: "",
        APPID: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        IMEI: "8545424a0797e8aa",
        LoginTypeID: 1,
        UserloginType: 2,
        UserID: otpMobile,
        Version: "1.0",
        LoginSource: "UserLogin",
      });

      setOtpSession(res.otpSession || "");
      toast.success(res.msg);
      setIsOtpSent(true);
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to send OTP. Please try again.");
    } finally {
      setIsSendingOtp(false);
    }
  }

  async function handleOtpLoginSubmit() {
    if (!otpValue.trim()) {
      toast.error("Please enter the OTP");
      return;
    }

    setIsVerifyingOtp(true);
    try {
      const res = await apiClient.post("/App/ValidateOTP", {
        appid: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        imei: "8545424a0797e8aa",
        oTPSession: otpSession,
        oTPType: 1,
        otp: otpValue,
        regKey: "",
        serialNo: "8545424a0797e8aa",
        version: "6.0",
      });

      if (res.statuscode !== 1) {
        toast.error(res.msg);
        return;
      }

      setCookie("sessionID", res.data.sessionID);
      setCookie("session", res.data.session);
      setCookie(
        "userData",
        JSON.stringify({
          userID: res.data.userID,
          name: res.data.name,
          prefix: res.data.prefix,
          mobileNo: res.data.mobileNo,
          emailID: res.data.emailID,
          roleID: res.data.roleID,
          roleName: res.data.roleName,
          outletID: res.data.outletID,
        }),
      );

      toast.success(res.msg);
      closeOtpModal();
      navigate("/panel/dashboard");
    } catch (err) {
      const message =
        err.response?.data?.message || "Login failed. Please try again.";
      toast.error(message);
    } finally {
      setIsVerifyingOtp(false);
    }
  }

  function openForgotModal() {
    setForgotUserId("");
    setIsForgotModalOpen(true);
  }

  function closeForgotModal() {
    setIsForgotModalOpen(false);
    setForgotUserId("");
  }

  async function handleSendForgotPassword() {
    if (!forgotUserId.trim()) {
      toast.error("Please enter User ID or Mobile No");
      return;
    }

    setIsSendingForgot(true);
    try {
      const res = await apiClient.post("/App/ForgetPassword", {
        LoginSource: "UserLogin",
        appid: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        imei: "8545424a0797e8aa",
        loginTypeID: 1,
        password: "",
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        userID: forgotUserId,
        version: "1.0",
      });

      if (res.statuscode == 1) {
        toast.success(res.msg);
        closeForgotModal();
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to send request. Please try again.");
    } finally {
      setIsSendingForgot(false);
    }
  }

  function handleCredsModalLogin() {
    setLoginForm((prev) => ({ ...prev, userID: registeredCreds.userId }));
    setActiveTab("login");
    setRegisteredCreds(null);
  }

  async function handleRegisterSubmit() {
    setRegisterError("");

    if (!registerForm.referalID.trim()) {
      setRegisterError("Referral Id required to fill");
      toast.error("Referral Id required  to fill");
      return;
    }

    setIsRegistering(true);
    try {
      const res = await apiClient.post("/App/AppUserSignup", {
        appid: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        imei: "8545424a0797e8aa",
        ReferalIDStr: registerForm.referalID,
        regKey: "",
        serialNo: "8545424a0797e8aa",
        userCreate: {
          address: "lucknow",
          emailID: registerForm.email,
          mobileNo: registerForm.mobileNo,
          name: registerForm.name,
          outletName: registerForm.name,
          pincode: "226022",
          ReferalIDStr: registerForm.referalID,
          roleID: 3,
        },
        version: "1.0",
      });

 if (res.statuscode !== 1) {
        setRegisterError(res.msg);
        toast.error(res.msg);
        return;
      }

      toast.success(res.msg);
      setRegisterForm(REGISTER_INITIAL_STATE);
      setRegisteredCreds({ userId: res.userId, password: res.password });
    } catch (err) {
      const message =
        err.response?.data?.message || "Registration failed. Please try again.";
      setRegisterError(message);
      toast.error(message);
    } finally {
      setIsRegistering(false);
    }
  }
  const fetchUserDetailById = async (referalId) => {
    setIsReferrerLoading(true);
    try {
      const res = await apiClient.post("/App/GetRoleForReferral", {
        appid: "ROUNDPAYAPPID13APR20191351",
        domain: "learning2earning.net",
        imei: "d593bdd26dfbea56",
        referralID: referalId,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setReferrerName(res.name || "");
        setReferrerNotFound(false);
      } else {
        setReferrerName("");
        setReferrerNotFound(true);
      }
    } catch (err) {
      console.log("error", err);
      setReferrerName("");
      setReferrerNotFound(true);
    } finally {
      setIsReferrerLoading(false);
    }
  };

  useEffect(() => {
    const referalID = String(registerForm.referalID || "").trim();
    if (!referalID) {
      setReferrerName("");
      setReferrerNotFound(false);
      return;
    }

    const timer = setTimeout(() => {
      fetchUserDetailById(referalID);
    }, 500);

    return () => clearTimeout(timer);
  }, [registerForm.referalID]);
  return (
    <>
      {beforeLoginPopupUrl && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
          onClick={() => setBeforeLoginPopupUrl(null)}
        >
          <div
            style={{ position: "relative", maxWidth: 480, width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <span
              onClick={() => setBeforeLoginPopupUrl(null)}
              style={{
                position: "absolute",
                top: -14,
                right: -14,
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#fff",
                color: "#111",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
              }}
            >
              &times;
            </span>
            <img
              src={beforeLoginPopupUrl}
              alt="Announcement"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 14,
                display: "block",
                boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
              }}
            />
          </div>
        </div>
      )}
      <div id="auth-screen">
        <div className="auth-wrap">
          <div className="auth-visual">
            <div className="brand-mark">
              <img src="/assets/panel/images/white-logo.png" />
            </div>
            <div className="cus-mobile-4587">
              <h1>
                Master the markets.
                <br />
                <em>Trade with conviction.</em>
              </h1>
              <p>
                Live mentorship, structured courses, and a rewards engine built
                for serious traders and the teams they build.
              </p>
            </div>
          </div>
          <div className="auth-form">
            <div className="tabs">
              <button
                className={`tab-btn${activeTab === "login" ? " active" : ""}`}
                id="tab-login"
                onClick={() => setActiveTab("login")}
              >
                Sign In
              </button>
              <button
                className={`tab-btn${activeTab === "register" ? " active" : ""}`}
                id="tab-register"
                onClick={() => setActiveTab("register")}
              >
                Sign Up
              </button>
            </div>
            <div
              id="form-login"
              style={{ display: activeTab === "login" ? "block" : "none" }}
            >
              <div className="field">
                <label>Mobile Number / User ID</label>
                <input
                  type="text"
                  name="userID"
                  placeholder="e.g. VP10234 or 98xxxxxxxx"
                  value={loginForm.userID}
                  onChange={handleLoginChange}
                />
              </div>
              <div className="field">
                <label>Password</label>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="••••••••"
                    name="password"
                    value={loginForm.password}
                    onChange={handleLoginChange}
                    style={{ width: "100%", paddingRight: "40px" }}
                  />

                  <span
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#888",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </span>
                </div>
              </div>
              {loginError && (
                <div className="auth-foot" style={{ color: "#e5484d" }}>
                  {loginError}
                </div>
              )}

              <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleLoginSubmit}
                  disabled={isLoggingIn}
                >
                  {isLoggingIn ? "Signing In..." : "Sign In "}
                </button>
              </div>

              <div
                className="cus-mobile-reset"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <div className="auth-foot" style={{ visibility: "hidden" }}>
                    Placeholder
                  </div>
                  <div className="auth-foot">
                    Forgot password?{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openForgotModal();
                      }}
                    >
                      Reset here
                    </a>
                  </div>
                </div>

                <div style={{ textAlign: "right" }}>
                  <div className="auth-foot">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        openOtpModal();
                      }}
                    >
                      Login with OTP
                    </a>
                  </div>
                  <div className="auth-foot">
                    <Link to="/">Back To Home</Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="form-register"
              style={{ display: activeTab === "register" ? "block" : "none" }}
            >
              <div className="field">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={registerForm.name}
                  onChange={handleRegisterChange}
                />
              </div>
              <div className="field">
                <label>Mobile No.</label>
                <input
                  type="text"
                  name="mobileNo"
                  placeholder="10-digit mobile number"
                  value={registerForm.mobileNo}
                  onChange={handleRegisterChange}
                />
              </div>
              <div className="field">
                <label>Email Id</label>
                <input
                  type="text"
                  name="email"
                  placeholder="Email Id"
                  value={registerForm.email}
                  onChange={handleRegisterChange}
                />
              </div>
              <div className="field">
                <label>Affiliate Referral id *</label>
                <input
                  type="text"
                  name="referalID"
                  placeholder="Enter Referral Id *"
                  value={registerForm.referalID}
                  onChange={handleRegisterChange}
                />
                {isReferrerLoading && (
                  <div
                    className="field-note"
                    style={{ color: "var(--text-faint)" }}
                  >
                    Checking...
                  </div>
                )}
                {!isReferrerLoading && referrerName && (
                  <div className="field-note">{referrerName}</div>
                )}
                {!isReferrerLoading && referrerNotFound && (
                  <div className="field-note" style={{ color: "var(--red)" }}>
                    Referral ID not found
                  </div>
                )}
              </div>
              {registerError && (
                <div className="auth-foot" style={{ color: "#e5484d" }}>
                  {registerError}
                </div>
              )}

              <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleRegisterSubmit}
                  disabled={isRegistering}
                >
                  {isRegistering ? "Creating Account..." : "Sign Up"}
                </button>
              </div>

              <div
                className="auth-foot mobile-auth-foot"
                style={{ color: "#e6b559", textAlign: "right" }}
              >
                <Link to="/">Back To Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {registeredCreds && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 380,
              background:
                "linear-gradient(160deg, var(--bg-elev-2), var(--bg-elev))",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius)",
              padding: "30px 28px",
              boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                margin: "0 auto 16px",
                borderRadius: "50%",
                background:
                  "linear-gradient(135deg, var(--green), var(--gold))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 26,
                boxShadow: "0 0 0 6px rgba(51,214,159,0.12)",
              }}
            >
              ✓
            </div>
            <h3
              style={{
                color: "var(--text)",
                fontSize: 18,
                fontWeight: 800,
                margin: "0 0 6px",
              }}
            >
              Account Created!
            </h3>
            <p
              style={{
                color: "var(--text-faint)",
                fontSize: 13,
                margin: "0 0 22px",
              }}
            >
              Save your credentials — you'll need them to log in.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "var(--bg-elev-3)",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-sm)",
                padding: "10px 14px",
                marginBottom: 10,
              }}
            >
              <span style={{ color: "var(--text-dim)", fontSize: 12 }}>
                User ID
              </span>
              <span
                className="mono"
                style={{ color: "var(--gold-bright)", fontWeight: 700 }}
              >
                {registeredCreds.userId}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "var(--bg-elev-3)",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-sm)",
                padding: "10px 14px",
                marginBottom: 24,
              }}
            >
              <span style={{ color: "var(--text-dim)", fontSize: 12 }}>
                Password
              </span>
              <span
                className="mono"
                style={{ color: "var(--gold-bright)", fontWeight: 700 }}
              >
                {registeredCreds.password}
              </span>
            </div>

            <button
              type="button"
              className="btn-primary"
              style={{ width: "100%" }}
              onClick={handleCredsModalLogin}
            >
              Continue to Login
            </button>
          </div>
        </div>
      )}

      {isForgotModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 380,
              background:
                "linear-gradient(160deg, var(--bg-elev-2), var(--bg-elev))",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius)",
              padding: "30px 28px",
              boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 18,
              }}
            >
              <h3
                style={{
                  color: "var(--text)",
                  fontSize: 18,
                  fontWeight: 800,
                  margin: 0,
                }}
              >
                Forgot Password
              </h3>
              <span
                onClick={closeForgotModal}
                style={{
                  cursor: "pointer",
                  color: "var(--text-faint)",
                  fontSize: 20,
                  lineHeight: 1,
                }}
              >
                &times;
              </span>
            </div>

            <div className="field">
              <label>User ID/MobileNo</label>
              <input
                type="text"
                placeholder="User ID/MobileNo"
                value={forgotUserId}
                onChange={(e) => setForgotUserId(e.target.value)}
              />
            </div>

            <button
              type="button"
              className="btn-primary"
              style={{ width: "100%", marginTop: 8 }}
              onClick={handleSendForgotPassword}
              disabled={isSendingForgot}
            >
              {isSendingForgot ? "Sending..." : "Send"}
            </button>
          </div>
        </div>
      )}

      {isOtpModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 380,
              background:
                "linear-gradient(160deg, var(--bg-elev-2), var(--bg-elev))",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius)",
              padding: "30px 28px",
              boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 18,
              }}
            >
              <h3
                style={{
                  color: "var(--text)",
                  fontSize: 18,
                  fontWeight: 800,
                  margin: 0,
                }}
              >
                Login with OTP
              </h3>
              <span
                onClick={closeOtpModal}
                style={{
                  cursor: "pointer",
                  color: "var(--text-faint)",
                  fontSize: 20,
                  lineHeight: 1,
                }}
              >
                &times;
              </span>
            </div>

            <div className="field">
              <label>MobileNo</label>
              <input
                type="text"
                placeholder="MobileNo"
                value={otpMobile}
                onChange={(e) => setOtpMobile(e.target.value)}
                disabled={isOtpSent}
              />
            </div>

            {!isOtpSent ? (
              <button
                type="button"
                className="btn-primary"
                style={{ width: "100%", marginTop: 8 }}
                onClick={handleSendOtp}
                disabled={isSendingOtp}
              >
                {isSendingOtp ? "Sending..." : "Send OTP"}
              </button>
            ) : (
              <>
                <div className="field" style={{ marginTop: 14 }}>
                  <label>Enter OTP</label>
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otpValue}
                    onChange={(e) => setOtpValue(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  className="btn-primary"
                  style={{ width: "100%", marginTop: 8 }}
                  onClick={handleOtpLoginSubmit}
                  disabled={isVerifyingOtp}
                >
                  {isVerifyingOtp ? "Verifying..." : "Submit"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
